import AdvancedSearchPage from './Page';
export default AdvancedSearchPage;
